import { render, staticRenderFns } from "./FraisPdf.vue?vue&type=template&id=40009c8c"
import script from "./FraisPdf.vue?vue&type=script&lang=ts"
export * from "./FraisPdf.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports